import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.704 4.153C16.7825 4.21263 16.8486 4.28716 16.8983 4.37233C16.948 4.4575 16.9804 4.55163 16.9937 4.64935C17.007 4.74706 17.0008 4.84643 16.9757 4.94178C16.9505 5.03713 16.9068 5.12657 16.847 5.205L8.847 15.705C8.78211 15.7901 8.69977 15.8602 8.60552 15.9108C8.51126 15.9615 8.40727 15.9913 8.30053 15.9984C8.19379 16.0055 8.08676 15.9897 7.98663 15.952C7.8865 15.9144 7.79559 15.8557 7.72 15.78L3.22 11.28C3.08752 11.1378 3.0154 10.9498 3.01882 10.7555C3.02225 10.5612 3.10096 10.3758 3.23838 10.2384C3.37579 10.101 3.56118 10.0223 3.75548 10.0188C3.94978 10.0154 4.13782 10.0875 4.28 10.22L8.174 14.113L15.654 4.296C15.7744 4.13796 15.9526 4.03413 16.1494 4.00732C16.3463 3.98051 16.5457 4.0329 16.704 4.153Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }